__turbopack_context__.v({
  "Footer2": "footer2-module__EKfZfq__Footer2",
  "FooterBg": "footer2-module__EKfZfq__FooterBg",
  "FooterIcon": "footer2-module__EKfZfq__FooterIcon",
  "FooterTxtdiv": "footer2-module__EKfZfq__FooterTxtdiv",
  "FooterdivRow": "footer2-module__EKfZfq__FooterdivRow",
  "Footerhr": "footer2-module__EKfZfq__Footerhr",
  "Footerhr2": "footer2-module__EKfZfq__Footerhr2",
  "Footerhrdiv": "footer2-module__EKfZfq__Footerhrdiv",
  "SocialIconBox": "footer2-module__EKfZfq__SocialIconBox",
  "SocialMediaContent": "footer2-module__EKfZfq__SocialMediaContent",
  "imgMo2": "footer2-module__EKfZfq__imgMo2",
  "logo2": "footer2-module__EKfZfq__logo2",
  "tinyFooter": "footer2-module__EKfZfq__tinyFooter",
});
